import { useState, useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import "./HeroSection.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const HeroSection = ({
  images = [],
  title = "The Gaza",
  subtitle = "Photo Diaries",
}) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const swiperRef = useRef(null);

  const togglePlay = () => {
    setIsPlaying((prev) => !prev);
  };

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      if (isPlaying) {
        swiperRef.current.swiper.autoplay.start();
      } else {
        swiperRef.current.swiper.autoplay.stop();
      }
    }
  }, [isPlaying]);

  return (
    <div className="portfolio-container heightt">
      <Swiper
        navigation={{
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        }}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        modules={[Navigation, Autoplay]}
        className="swiper-container"
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <div className="image-wrapper">
              <img
                src={src}
                alt={`Slide ${index + 1}`}
                className="portfolio-image"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="portfolio-text">
        <div className="portfolio-text2">{title}</div>
        {subtitle}
      </div>

      <div className="swiper-nav-buttons">
        <div className="swiper-button-next-custom">
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
        <div className="swiper-button-prev-custom">
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
